/* ============================================================================
   TAXONOMY — COMPONENTS (Onglet 3 : Components)
   Champs 1 à 3 : Main flows / External connections / Disciplines
   Objectif : libellés praticiens, non ambigus, utilisables sur différents secteurs.
   NOTE : on conserve les codes (value) existants pour éviter toute dette / rupture.
============================================================================ */

/* --- (1) MAIN SYSTEMS / FLOWS -------------------------------------------- */
/**
 * Question praticien : "Quels sont les flux / systèmes principaux à considérer
 * dans le schéma de base ?"
 * Usage : multi-sélection (plusieurs flux coexistent presque toujours).
 */
export const MAIN_FLOWS_OPTIONS = [
  { value: "WATER", label: "Eau (potable / brute / process)" },
  { value: "ENERGY", label: "Énergie (électricité / secours / carburant)" },
  { value: "PROCESS_FLUIDS", label: "Fluides de procédé (air, vapeur, gaz, produits)" },
  { value: "PEOPLE", label: "Exploitation (personnel / accès / circulation)" },
  { value: "VEHICLES", label: "Logistique (véhicules / engins / livraisons)" },
  { value: "DATA", label: "Contrôle & données (SCADA, IT/OT, télécom)" },
  { value: "MATERIALS", label: "Consommables & matériaux (réactifs, pièces, stocks)" },
];

/* --- (2) EXTERNAL CONNECTIONS -------------------------------------------- */
/**
 * Question praticien : "À quoi le projet est-il raccordé / interfaced à l'extérieur ?"
 * Usage : multi-sélection (peut cumuler réseaux publics + tie-ins + accès).
 */
export const EXTERNAL_CONNECTIONS_OPTIONS = [
  { value: "PUBLIC_NETWORKS", label: "Réseaux publics (eau / élec / assainissement)" },
  { value: "UTILITIES", label: "Utilités industrielles (air / vapeur / azote / etc.)" },
  { value: "THIRD_PARTY_NETWORKS", label: "Réseaux tiers / concessionnaires (opérateurs)" },
  { value: "EXISTING_SITE_TIE_INS", label: "Raccordements à l’existant (tie-ins / bascules)" },
  { value: "PUBLIC_ACCESS", label: "Accès usagers / public (contrôles, flux, sécurité)" },
];

/* --- (3) DISCIPLINES ------------------------------------------------------ */
/**
 * Question praticien : "Quelles disciplines seront effectivement mobilisées
 * (pour générer une structure WBS/N2 réaliste) ?"
 * Usage : multi-sélection.
 * NOTE : on garde "I&C" comme code (car déjà utilisé), label explicite.
 */
export const DISCIPLINES_OPTIONS = [
  { value: "ARCH", label: "Architecture (bâtiment, enveloppe, aménagements)" },
  { value: "CIVIL", label: "Génie civil (terrassements, plateformes, ouvrages enterrés, bassins)" },
  { value: "STRUCT", label: "Structure (béton armé, métal, charpentes, fondations)" },
  { value: "MEP", label: "Techniques bâtiment (électricité, HVAC, plomberie, SSI)" },
  { value: "POWER", label: "Électricité de puissance (postes, HT/BT, distribution)" },
  { value: "PROCESS", label: "Procédé industriel / traitement (unités process)" },
  { value: "MECHANICAL", label: "Mécanique industrielle (équipements, pompes, machines)" },
  { value: "PIPING", label: "Piping & réseaux de fluides (tuyauteries process / utilités)" },
  { value: "I&C", label: "Instrumentation & contrôle-commande (capteurs, PLC, SCADA)" },
  { value: "INFRA_VRD", label: "Infrastructure & VRD (voirie, routes, drainage, réseaux humides et secs)" },
];
/* --- ARCHITECTURE (Onglet Components) ------------------------------------ */
/* 4 champs : Organisation globale / Topologie des interconnexions /
              Approche de modularité / Stratégie d’extension                */

/* 1. Organisation globale des fonctions */
export const SYSTEM_ORGANIZATION_OPTIONS = [
  { value: "CENTRALIZED", label: "Centralisée (un pôle principal)" },
  { value: "DISTRIBUTED", label: "Distribuée (plusieurs pôles / entités)" },
];


/* 3. Approche de modularité */
export const MODULARITY_APPROACH_OPTIONS = [
  { value: "LOW", label: "Sur-mesure (chaque unité est spécifique)" },
  { value: "PARTIAL", label: "Partiellement modulaire (quelques modules répétables)" },
  { value: "HIGH", label: "Fortement modulaire (modules standardisés)" },
];






/* System Strategy */

/* 2. Topologie des interconnexions */
export const INTERCONNECTION_TOPOLOGY_OPTIONS = [
  { value: "COMPACT", label: "Compacte (principalement intra-site)" },
  { value: "LINEAR", label: "Linéaire (par tronçons / chaîne)" },
  { value: "NETWORK", label: "En réseau (maillage / secteurs)" },
  { value: "MIXED", label: "Mixte (combinaison de modèles)" },
];

/* 4. Stratégie d’extension / évolutivité */
export const EXPANSION_STRATEGY_OPTIONS = [
  { value: "NONE", label: "Pas d’extension prévue" },
  { value: "EXPANDABLE", label: "Extension possible (capacité additionnelle)" },
  { value: "REPLICABLE", label: "Réplication d’unités identiques" },
  { value: "PHASED", label: "Extension par phases (jalons d’augmentation)" },
];